import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import About from "./components/About";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Home from "./pages/Home";
import Navigation from "./components/Navbar";
import Quote from "./components/Quote";
import Services from "./components/Services";
import QR from "./pages/QR";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Layout wrapper to conditionally show nav/footer
function Layout({ children, onQuoteClick, isQuoteOpen, onQuoteClose, selectedService }) {
  const location = useLocation();
  const isQRPage = location.pathname === "/qr";

  return (
    <>
      {!isQRPage && <Navigation onQuoteClick={onQuoteClick} />}
      {children}
      {!isQRPage && <Footer onQuoteClick={onQuoteClick} />}
      <Quote isOpen={isQuoteOpen} onClose={onQuoteClose} preselectedService={selectedService} />
    </>
  );
}

function App() {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");

  const handleQuoteOpen = (service = "") => {
    setSelectedService(service);
    setIsQuoteOpen(true);
  };

  const handleQuoteClose = () => {
    setIsQuoteOpen(false);
    setSelectedService("");
  };

  return (
    <Router>
      <ScrollToTop />
      <Layout
        onQuoteClick={handleQuoteOpen}
        isQuoteOpen={isQuoteOpen}
        onQuoteClose={handleQuoteClose}
        selectedService={selectedService}
      >
        <Routes>
          <Route path="/about" element={<About onQuoteClick={handleQuoteOpen} />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/" element={<Home onQuoteClick={handleQuoteOpen} />} />
          <Route path="/services" element={<Services onQuoteClick={handleQuoteOpen} />} />
          <Route path="/qr" element={<QR />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
